import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorCorporateEmployeeWarehouseSearch = () => {
  const corporateEmployeeWarehouseSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/corporate/employee-warehouse/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { corporateEmployeeWarehouseSearch }
}

export default InteractorCorporateEmployeeWarehouseSearch
